export const errorMessages = {
    SYSTEM_ERROR: 'Có lỗi xảy ra, vui lòng thử lại',
    UPDATE_FAIL: 'Cập nhật thất bại, vui lòng thử lại sau'
}

export const successMessages = {
    UPDATE_COMMON: 'Cập nhật thành công'
}